import React, { Component, Fragment, useState, useRef } from 'react';
import { ApiEndpoints } from '../../../../api/apiEndpoints';
import { ModalWindow } from '../../../modal/ModalWindow';

export function ShopDeliveryDeleteModal({deleteDeliveryId, setDeleteDeliveryId, fetchDeliveries}) {
    const modalWindowRef = useRef();
    const [submitting, setSubmitting] = useState(false);

    const confirmDelete = async (e) => {
        if (submitting) return;
        setSubmitting(true);

        await fetch(`${ApiEndpoints.ManageShopDeliveries}/${deleteDeliveryId}`, { method: "DELETE" });
        fetchDeliveries();
        modalWindowRef.current.closeWindow();
    }

    return (
        <ModalWindow
            ref={modalWindowRef}
            title="Confirm Delete"
            onClose={() => setDeleteDeliveryId(null)}
        >
            <p>Are you sure you want to delete this delivery?</p>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => modalWindowRef.current.closeWindow()}>Cancel</button>
              <button type="button" className="btn btn-danger" onClick={confirmDelete} disabled={submitting}>Delete</button>
            </div>
        </ModalWindow>
    );
}